import React from "react";
import { Card, Typography, Row, Col, Tag } from "antd";
import { BarcodeOutlined, DollarOutlined, UserOutlined, CarOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const CardFolowFreigth = ({
  numberSerial,
  product,
  weightCargo,
  valueNF,
  valueFreightage,
  user,
  clientPayment,
  vehicle,
  typeBodywork,
  typeVehicle,
  nameDriver,
}) => {
  const bodyworkList = Array.isArray(typeBodywork) ? typeBodywork : [];
  const vehicleTypeList = Array.isArray(typeVehicle) ? typeVehicle : [];
  const selectedBodywork = bodyworkList.find((item) => item?.selected);
  const selectedVehicle = vehicleTypeList.find((item) => item?.selected);
  const currencyBRL = (value) =>
    (value || 0).toLocaleString("pt-br", { style: "currency", currency: "BRL" });

  const infoLine = (label, value) => (
    <div style={{ marginBottom: 10 }}>
      <Text strong style={{ color: "#334155" }}>
        {label}:{" "}
      </Text>
      <Text style={{ color: "#0f172a" }}>{value || "Nao informado"}</Text>
    </div>
  );

  return (
    <Card
      title={
        <Title level={4} style={{ margin: 0, color: "#595959" }}>
          Informações do Transporte
        </Title>
      }
      bordered={false}
      style={{
        width: "100%",
        maxWidth: 560,
        margin: "5px auto",
        padding: "8px",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
      }}
      headStyle={{ backgroundColor: "#fafafa", borderBottom: "1px solid #f0f0f0" }}
    >
      <Row gutter={[12, 12]}>
        <Col xs={24} md={12}>
          <Card size="small" style={{ borderRadius: 10, borderColor: "#dbeafe", background: "#eff6ff" }}>
            <Text type="secondary">Valor NF</Text>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
              <DollarOutlined style={{ color: "#16a34a", marginRight: 8 }} />
              {currencyBRL(valueNF)}
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card size="small" style={{ borderRadius: 10, borderColor: "#ffedd5", background: "#fff7ed" }}>
            <Text type="secondary">Valor do Frete</Text>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
              <DollarOutlined style={{ color: "#ea580c", marginRight: 8 }} />
              {currencyBRL(valueFreightage)}
            </div>
          </Card>
        </Col>

        <Col span={24}>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              padding: "12px 14px",
              background: "#ffffff",
            }}
          >
            <div style={{ marginBottom: 8 }}>
              <Text>
                <BarcodeOutlined style={{ color: "#2563eb", marginRight: 8 }} />
                <Text strong>Numero do Frete:</Text>
                <Link to={`/freightCopy/${numberSerial}`} style={{ color: "#2563eb", marginLeft: 8 }}>
                  {numberSerial || "Nao informado"}
                </Link>
              </Text>
            </div>
            {infoLine("Produto", product)}
            {infoLine("Peso da Carga", weightCargo ? `${weightCargo} kg` : null)}
            {infoLine("Nome do Motorista", nameDriver)}
          </div>
        </Col>

        <Col xs={24} md={12}>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              padding: "12px 14px",
              background: "#ffffff",
              height: "100%",
            }}
          >
            <Text strong style={{ display: "block", marginBottom: 10, color: "#334155" }}>
              Envolvidos
            </Text>
            <div style={{ marginBottom: 10 }}>
              <UserOutlined style={{ color: "#7c3aed", marginRight: 8 }} />
              <Text strong>Usuario:</Text> <Text>{user?.name || "Nao informado"}</Text>
            </div>
            <div>
              <Tag color="gold" style={{ marginRight: 8 }}>
                Embarcador
              </Tag>
              <Text>{clientPayment?.name || "Nao informado"}</Text>
            </div>
          </div>
        </Col>

        <Col xs={24} md={12}>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              padding: "12px 14px",
              background: "#ffffff",
              height: "100%",
            }}
          >
            <Text strong style={{ display: "block", marginBottom: 10, color: "#334155" }}>
              Veiculo
            </Text>
            <div style={{ marginBottom: 10 }}>
              <CarOutlined style={{ color: "#0891b2", marginRight: 8 }} />
              <Text strong>Ocupacao:</Text> <Text>{vehicle?.occupation || "Nao informado"}</Text>
            </div>
            <div style={{ marginBottom: 8 }}>
              <Tag color={selectedBodywork ? "green" : "red"} style={{ marginRight: 8 }}>
                Carroceria
              </Tag>
              <Text>{selectedBodywork?.name || "Nao selecionado"}</Text>
            </div>
            <div>
              <Tag color={selectedVehicle ? "green" : "red"} style={{ marginRight: 8 }}>
                Tipo
              </Tag>
              <Text>{selectedVehicle?.name || "Nao selecionado"}</Text>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardFolowFreigth;
